import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  useTheme,
} from '@mui/material';
import { useRemixActions, useCurrentRemixerSong } from '../../hooks';

const ErrorDialog = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const currentSong = useCurrentRemixerSong();
  const remixerError = currentSong?.error ?? null;

  const { deleteRemix, retryRemix } = useRemixActions();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    setIsModalOpen(Boolean(remixerError));
  }, [remixerError]);

  const goBack = useCallback(() => {
    deleteRemix();
    closeModal();
  }, [deleteRemix]);

  const retry = useCallback(() => {
    retryRemix();
    closeModal();
  }, [retryRemix]);

  return (
    <Dialog
      PaperProps={{
        sx: {
          background: theme.palette.common.white,
          padding: theme.spacing(2),
          borderRadius: theme.spacing(1),
        },
      }}
      keepMounted
      open={isModalOpen}
      onClose={goBack}
    >
      <DialogTitle
        sx={{
          color: theme.palette.common.black,
        }}
      >
        {t('remixer:errorDialog:title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: theme.palette.common.black }}>
          {t('remixer:errorDialog:description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="textDark" onClick={goBack}>
          {t('remixer:errorDialog:actions:goBack')}
        </Button>
        <Button variant="rounded" onClick={retry}>
          {t('remixer:errorDialog:actions:retry')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
